import SelectWeex from "../elements/SelectWeex";
import {sexes} from '../ToDos.js';
import {uploadImage} from "../api/APIfunctions.tsx";
import {useState} from "react";

export default function PersonEditView({
                                           user,
                                           handleChange,
                                           updateEgo,
                                           handleExit,
                                           sex,
                                           setSex,
                                           handleChangeAddress
                                       }){
    const [loading, setLoading] = useState(false)

    return (
        <div className={"grid gridtwo-flex"} style={{width: "50%", rowGap: "4%"}}>
            <label> Vorname: </label>
            <input type="text" name="firstname" onChange={handleChange} value={user.firstname}/>
            <label> Nachname: </label>
            <input type="text" name="lastname" onChange={handleChange} value={user.lastname}/>
            <label> E-Mail: </label>
            <input type="email" name="email" onChange={handleChange} value={user.email}/>
            <label> Foto: </label>
            <input type="file" name="photo" accept="image/*"
                   onChange={(e) => {
                       setLoading(true)
                       uploadImage(e.target.files[0], (e, a) => console.log(e + a)).then(response => {
                           handleChange({target: {name: "photo", value: response.info}});
                           setLoading(false)
                       });
                   }}/>
            <label> Telefonnummer: </label>
            <input type="tel" name="phone" onChange={handleChange} value={user.phone}/>
            <label> Geburtstag: </label>
            <input type="date" name="birthday" onChange={handleChange} value={user.birthday}/>
            <label> Geschlecht: </label>
            <SelectWeex options={sexes}
                        onChange={setSex}
                        placeholder={"M/W/D"}
                        isMulti={false}
                        value={sex}
                        isClearable={false}
                        style={{width: 110}}
            />
            <label> Adresse: </label>
            <details className={"flex-column"}>
                <summary>Rechnungsadresse</summary>
                <div>
                    <label htmlFor="street">Straße:</label>
                    <input
                        type="text"
                        id="street"
                        name="street"
                        value={user.address?.street || ""}
                        onChange={handleChangeAddress}
                    />
                </div>
                <div className={"flex-row"}>
                    <div>
                        <label htmlFor="zip">PLZ:</label>
                        <input
                            type="text"
                            id="zip"
                            name="zip"
                            value={user.address?.zip || ""}
                            onChange={handleChangeAddress}
                        />
                    </div>
                    <div>
                        <label htmlFor="city">Ort:</label>
                        <input
                            type="text"
                            id="city"
                            name="city"
                            value={user.address?.city || ""}
                            onChange={handleChangeAddress}
                        />
                    </div>
                </div>
                <div>
                    <label htmlFor="country">Land:</label>
                    <input
                        type="text"
                        id="country"
                        name="country"
                        value={user.address?.country || ""}
                        onChange={handleChangeAddress}
                    />
                </div>
            </details>
            {/*<label> Maximale Tickets: </label>*/}
            {/*<label> {user?.ticketsMax} </label>*/}
            {/*ist jetzt für den Boxbesitzer, hat der selber überhaupt Tickets?*/}
            {/*<label> Tickets: </label>*/}
            {/*<input type="number" name="tickets" onChange={handleChange} value={user.tickets}/>*/}
            {/*<label> Kurse: </label>*/}
            {/*<p>{user.courses}</p>*/}
            <div style={{gridColumn: "span 2"}}>
                <span className={"error-message"} id={"error-message"}></span>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <button className={"primarybutton"} onClick={updateEgo} disabled={loading}
                            style={{width: "auto", marginRight: "2%"}}>
                        Änderungen speichern
                    </button>
                    <button className={"secondarybutton"} onClick={handleExit}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    );
}


